export const CREDENTIAL_VALID = 'valid';
export const CREDENTIAL_INVALID = 'invalid';
export const CREDENTIAL_UNTESTED = 'untested';
